export default __webpack_public_path__ + "static/media/bulb.fcf3bd7b.svg";